import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import { HistoryCardResponseData } from "../projects/types"
import {
	CalculateCarbonReductionRequest,
	CalculateCarbonReductionResponse,
	CreateDeclarationData,
	CreateDeclarationResponse,
	DeclarationDetailsResponse,
	DeclarationLanguagesResponse,
	DeclarationSummaryResponse,
	DownloadAllDeclarationsRequest,
	PreviousProjectData,
} from "./types"

export const calculateCarbonReduction = (
	apiClient: APIClient,
	request: CalculateCarbonReductionRequest,
	signal?: AbortSignal,
): Promise<CalculateCarbonReductionResponse> =>
	apiClient
		.post<CalculateCarbonReductionResponse>(
			"/declarations/calculate-carbon-reduction",
			request,
			{ signal },
		)
		.then(response => response.data)

export const getDeclarationByTransactionId = (
	apiClient: APIClient,
	declarationId: string,
	language: string,
): Promise<ArrayBuffer> =>
	apiClient
		.get(`/declarations/${declarationId}`, {
			params: { language },
			responseType: "arraybuffer",
		})
		.then(response => response.data)

export const getAllDeclarations = (
	apiClient: APIClient,
	request: DownloadAllDeclarationsRequest,
): Promise<ArrayBuffer> =>
	apiClient
		.post("/declarations/download-batch", request, {
			responseType: "arraybuffer",
		})
		.then(response => response.data)

export const getPreviousProjects = (
	apiClient: APIClient,
): Promise<PreviousProjectData> =>
	apiClient
		.get("/declarations/project-references/names")
		.then(response => response.data)

export const createDeclaration = (
	apiClient: APIClient,
	data: CreateDeclarationData,
): Promise<CreateDeclarationResponse> =>
	apiClient.post("/declarations", data).then(response => response.data)

export const getDeclarationDetails = (
	apiClient: APIClient,
	recordId: string,
	transactionId: string,
): Promise<DeclarationDetailsResponse> =>
	apiClient
		.get("/declarations/holder-details", {
			params: { recordId, transactionId },
		})
		.then(response => response.data)

export const getDeclarationSummary = (
	apiClient: APIClient,
	transactionId: string,
): Promise<DeclarationSummaryResponse> =>
	apiClient
		.get(`/declarations/${transactionId}/summary`)
		.then(response => response.data)

export const getHistoryCardDataByTransaction = (
	apiClient: APIClient,
	transactionId: string,
): Promise<HistoryCardResponseData> =>
	apiClient
		.get(`/declarations/history-cards/transaction/${transactionId}`)
		.then(response => response.data)

export const checkTransactionExists = (
	apiClient: APIClient,
	transactionId: string,
): Promise<{ exists: boolean }> =>
	apiClient
		.get("/declarations/exists", { params: { transactionId } })
		.then(response => response.data)

export const getDeclarationLanguagesByTransactionId = (
	apiClient: APIClient,
	declarationId: string,
): Promise<DeclarationLanguagesResponse> =>
	apiClient
		.get(`/declarations/${declarationId}/languages`)
		.then(response => response.data)
